import Vue from 'vue'
import '@/vendor'
import App from './App.vue'
import router from './router'
import store from './store/index'
import Api from '@/services/Api'
import i18n from './i18n'
import Alert from '@/elements/Alert'
import Spinner from '@/elements/TheSpinner'
import ProductLogo from '@/elements/ProductLogo'
import focus from '@/directives/focus'
import { handleAndLogError } from '@/utils/error'
import VueGtm from '@gtm-support/vue2-gtm'

Vue.component('Alert', Alert)
Vue.component('Spinner', Spinner)
Vue.component('ProductLogo', ProductLogo)
Vue.directive('focus', focus)

Vue.config.productionTip = false
Vue.config.errorHandler = handleAndLogError

// Refresh the API nonce on any request error: the nonce is single-use, so a
// failed request has consumed it and the next request needs a fresh one.
Api.interceptors.response.use(null, (err) => {
  // skip the nonce fetch itself, otherwise a failing refresh loops forever
  if (!err.config?.url?.includes('/server/__nonce__')) {
    // swallow: this is a background refresh, and the original error below is
    // what the caller is waiting to handle
    store.dispatch('fetchApiNonce').catch(() => {})
  }
  return Promise.reject(err)
})

Vue.use(VueGtm, {
  id: router.currentRoute.params?.is_lyber ? process.env.VUE_APP_LYBER_GTM_ID : process.env.VUE_APP_GTM_ID,
  vueRouter: router,
  loadScript: false
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
